import { CookieNames, getCookie } from '../helpers/cookie.helper';
import axios from './axiosConfig';

export const getDashboardStats = async () => {
    try {
        const response = await axios.get(`/api/Dashboard/GetDashboardStats`, {
            params: {
                SessionId: getCookie(CookieNames.SESSION_ID),
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}


export const getDashboardRevenueChartData = async (params = {
    CompanyId: '',
    FromDate: '',
    ToDate: ''
}) => {
    try {
        const response = await axios.get(`/api/Dashboard/GetDashboardRevenueChartData`, {
            params: {
                ...params,
                SessionId: getCookie(CookieNames.SESSION_ID),
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}